import { RunsHubService } from '../runs-hub.service';
import { Observable } from 'rxjs';
import { RunHistory } from 'src/app/runs/run-history.model';
import { Run } from 'src/app/runs/run.model';

import { Injectable } from '@angular/core';

import { StoreService } from '../../core/services/store/store.service';
import { RunsService } from '../runs.service';
import { RunState } from './run.state';

@Injectable({
  providedIn: 'root'
})
export class RunStoreService extends StoreService<RunState> {
  runs$: Observable<Run[] | undefined> = this.select("runs");
  loadFailed$: Observable<boolean | undefined> = this.select("loadFailed");

  runHistories$: Observable<RunHistory[] | undefined> = this.selectWith((state) => state.runs?.flatMap((run) => run.runHistories));

  constructor(private runsService: RunsService, private runsHubService: RunsHubService) {
    super();
    this.load();
    this.startHubConnection();
    this.runStatusListener();
  }

  load(): void {
    this.runsService.getRuns().subscribe({
      next: (runs) => this.setState({ runs, loadFailed: false }),
      error: () => this.setState({ loadFailed: true })
    });
  }

  startHubConnection() {
    this.runsHubService.startConnection().subscribe(() => {
      this.runsHubService.joinGroup();
    });
  }
  
  runStatusListener(): void {
    this.runsHubService.runStatusChanged().subscribe(this.handleRunStatusChanged);
  }

  handleRunStatusChanged = ({runId}: {runId: string}): void => {
    this.runsService.getRun(runId).subscribe((run) => {
      const runs = this.currentValue("runs");

      if (runs) {
        const index = runs.findIndex((run) => run.runId === runId);

        if (index !== -1) {
          runs[index] = run;
        } else {
          runs.unshift(run);
        }

        this.set('runs', runs);
      }
    });
  };
}
